import axios from "axios";

const instance = axios.create({
	baseURL: 'https://api.asista.kz'
});

export default instance;
